import { Pipe, PipeTransform } from '@angular/core';
import { differenceInYears, differenceInMonths, differenceInDays, addYears, addMonths } from 'date-fns';

@Pipe({
  name: 'dateAgo',
  pure: true
})
export class DateAgoPipe implements PipeTransform {

  transform(value: any): any {
    if (value) {
      const currentDate = new Date();
      const targetDate = new Date(value);

      // Calculate the difference in years, months, and days
      const years = differenceInYears(currentDate, targetDate);
      const months = differenceInMonths(currentDate, addYears(targetDate, years)) % 12;
      const days = differenceInDays(currentDate, addMonths(addYears(targetDate, years), months));

      let result = '';

      // Format the output based on the calculated values
      if (years > 0) {
        result += years + (years === 1 ? ' year, ' : ' years, ');
      }

      if (months > 0) {
        result += months + (months === 1 ? ' month, ' : ' months, ');
      }

      if (days > 0) {
        result += days + (days === 1 ? ' day' : ' days');
      }

      // If no years, months, or days, return 'Today'
      if (!result) {
        return 'Today';
      }

      // Remove trailing comma and space if any
      return result.trim().replace(/,\s*$/, '');
    }
    
    return value;
  }
}
